<template>
    <div class="login">
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12">
                <div class="login-form" v-if="!changeSuccess" key="forms">
                    <transition name="fade" mode="out-in">
                        <form v-if="!submitSuccess" key="request">
                            <div class="login-form__title text_15 text_bold">{{ $t("lk_recover_title") }}</div>
                            <div class="text_11">
                                {{ $t("lk_recover_description") }}
                            </div>
                            <div class="form-group" v-for="(input, name, inputIndex) in form" :key="inputIndex">
                                <Input
                                    :inputClass="input.inputClass"
                                    :isValid="input.required ? input.isValid : true"
                                    :validationMessage="input.required ? input.validationMessage : ''"
                                    :type="input.type"
                                    :name="name"
                                    :label="input.label"
                                    :labelDescription="input.labelDescription"
                                    :required="input.required"
                                    :cleaveOptions="input.cleaveOptions"
                                    v-model="input.value"
                                    :suggestion="input.suggestion" />
                            </div>
                            <div class="form-group login-submit">
                                <div class="button button--dark button--wide" @click="submitForm">
                                    {{ $t("send") }}
                                </div>
                            </div>
                        </form>
                        <div key="change">
                            <div class="login-form__title text_15 text_bold">{{ $t("lk_recover_success_title") }}</div>
                            <div class="text_11">
                                {{ $t("lk_recover_success_description") }}
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="error text_11" v-if="errorMessage">{{ errorMessage }}</div>
                    </transition>
                </div>
            </div>
            <div class="col lg-6 sm-12 col--no-padding login-img">
                <UiImage :path="img" :desktop="{ width: 1016 }" :lazy="false" />
            </div>
        </div>
    </div>
</template>
<script>
import Input from "~/components/form/Input";
import { mapGetters } from "vuex";
import UiImage from "../../components/ui/Image.vue";

export default {
    name: "Recover",
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },
    components: {
        UiImage,
        Input,
    },
    async asyncData({ $axios }) {
        try {
            return {
                img: (await $axios.get("/api/page-images/recover")).data.img,
            };
        } catch (e) {
            console.log(e);
        }
    },
    data() {
        return {
            errorMessage: "",
            submitSuccess: false,
            changeSuccess: false,
            form: {
                email: {
                    label: this.$i18n.t("el_mail"),
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
            },
            img: null,
        };
    },
    watch: {
        async langust() {
            this.$store.commit("crumbs/change", this.getCrumbs());
            this.form.email.label = this.$i18n.t("el_mail");
        },
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("recover_password"),
                },
            ];
        },
        submitForm() {
            this.errorMessage = "";
            try {
                this.$axios.get("/api/auth/xsrf_token").then(async () => {
                    try {
                        let res = await this.$axios.post("/api/reset_password/request_code", {
                            email: this.form.email.value,
                        });
                        if (res.data.success == 1) {
                            this.submitSuccess = true;
                        } else {
                            this.processError(res, this.form);
                        }
                    } catch (error) {
                        this.processError(error, this.form);
                    }
                });
            } catch (error) {
                this.processError(error, this.form);
            }
        },

        processError(error, form) {
            this.isLoading = false;
            if (error.response) {
                if (error.response.status == 406) {
                    let notValidFields = error.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (form[name]) {
                                form[name].isValid = false;
                                form[name].validationMessage = element[0];
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({
                            block: "center",
                            behavior: "smooth",
                        });
                        elem.focus();
                    }
                } else {
                    this.errorMessage = error.response.data.error;
                }
            } else {
                console.log(`error =>`, error);
            }
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());
    },
};
</script>
<style lang="less" scoped>
.button--wide {
    width: 66%;
    @media @sm {
        width: 100%;
    }
}

.login {
    z-index: 1;
    background: #fff;

    &-img {
        img {
            width: 100%;
        }
    }
}

.login-form {
    padding-top: 40px;

    &__title {
        margin-bottom: 24px;
    }

    @media @sm {
        padding-top: 24px;
        padding-bottom: 24px;
    }
}

.login-submit {
    margin-top: 24px;
    margin-bottom: 16px;
    height: 48px;

    .button {
        height: 48px;
    }

    .button--text {
        text-decoration: underline;
        padding: 0 60px;
        margin-left: 16px;
        text-underline-offset: 3px;
        text-decoration-skip: none;
        text-decoration-skip-ink: none;
        @media @sm {
            margin-left: 0;
            margin-top: 8px;
            width: 100%;
        }
    }

    @media @sm {
        height: auto;
        flex-direction: column;
    }
}
</style>
